/* eslint-disable padding-line-between-statements */
import { useModal } from '@jutro/components';
import React, { useContext, useCallback, useEffect, useState } from 'react'
import _ from 'lodash'
import { BreakpointTrackerContext } from '@jutro/layout';
import { TranslatorContext } from '@jutro/locale';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, useDataRefresh, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import msbInfoUtil from 'ent-capability-quoteandbind-common-react/util/MsbInfoUtil.js';
import TWIAHoConstructionUtil from '../../../util/TWIAHoConstructionUtil';
import metadata from './TWIAAdditionalDetails.metadata.json5';
import messages from './TWIAAdditionalDetails.messages'

import { Button } from '@jutro/legacy/components';

function TWIAAdditionalDetails(props) {
    const { submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate, isRenewal, isEitherChangeOrRenewal, authHeader, hasMSBDataRefreshed } = props;
    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const[showBuildingCodeClass, setShowBuildingCodeClass] = useState(false);
    const[showBuildingCode, setShowBuildingCode] = useState(false);
    
    const[buildingCodeClassAvailableValues, setBuildingCodeClassAvailableValues] = useState([]);
    const[buildingCodeAvailableValues, setBuildingCodeAvailableValues] = useState([]);
    const [dateMismatchValidationMessage, setDateMismatchValidationMessage] = useState([]);
    const [yearMismatchValidationMessage, setYearMismatchValidationMessage] = useState([]);
    const [futureYearValidationMessage, setFutureYearValidationMessage] = useState([]);
    const [historicStructureAvilable, setHistoricStructureAvailable] = useState(false)
    const constructionDate= _.get(submissionVM,'lobData.homeowners.coverables.construction.originalConstDate_TWIA.value')

    const { refreshData } = useDataRefresh();
    const structureType = _.get(submissionVM, 'lobData.homeowners.coverables.yourHome.structureType_TWIA.value')
    const historicStructure = _.get(submissionVM, 'lobData.homeowners.coverables.construction.hasQualifyForHistStruct_TWIA');
    const isGlazedRetrofitVisible = _.get(submissionVM, 'lobData.homeowners.coverables.construction.hasCertificateOfComplianceGlazedRetrofit_TWIA.aspects.visible');
    const propertyEligibility = _.get(submissionVM, 'lobData.homeowners.coverables.construction.hasSB1702EligibilityException_TWIA');
    const isWPI8CertificateVisible = _.get(submissionVM, 'lobData.homeowners.coverables.construction.hasWPI8CertOfCompIssued_TWIA.aspects.visible');
    const yearBuilt = _.get(submissionVM, 'lobData.homeowners.coverables.construction.yearBuilt.value');
    const policyTypeCode = _.get(submissionVM, 'lobData.homeowners.policyType_TWIA.value.code');
    const MIN_YEARS_QUALIFY_HISTORIC_STRUCTURE = 49;
    const { onValidate: setComponentValidation, isComponentValid } = useValidation('TWIAAdditionalDetails');
    const [yearBuiltSnapshot, setYearBuiltSnapshot] = useState(0);
    
    
    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, 'TWIAAdditionalDetails');
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        findInvalidComponent(isComponentValid, 'TWIAAdditionalDetails');
    }, [findInvalidComponent, isComponentValid])

    useEffect(() => {
        // DE15498
        if (submissionVM.lobData.homeowners.coverables.construction.structureType_TWIA !== undefined) {
            _.set(submissionVM, 'lobData.homeowners.coverables.construction.structureType_TWIA.value', structureType);
        }
        if (_.get(submissionVM, 'lobData.homeowners.policyType_TWIA.value.code') === 'TWRM') {
            setShowBuildingCodeClass(false);
        }
        if (_.get(submissionVM, 'lobData.homeowners.coverables.construction.allRequiredFieldsValidation_TWIA.value') === undefined
            && _.get(submissionVM, 'lobData.homeowners.coverables.construction.value') !== undefined) {
            _.set(submissionVM, 'lobData.homeowners.coverables.construction.allRequiredFieldsValidation_TWIA.value', true);
        }
        if (_.get(submissionVM.value, 'lobData.homeowners.policyType_TWIA') === 'TWRD' && msbInfoUtil(submissionVM, updateWizardData, authHeader).shouldLaunchMSB_TWIA()) {
            _.set(submissionVM, 'lobData.homeowners.coverables.construction.hasSB1702EligibilityException_TWIA.value', false)
        }// DE17841 - defaulting the value to 'No' as in PC
        updateWizardData(submissionVM)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // DE17805
    useEffect(() => {
        if (historicStructure && historicStructure.value === undefined && historicStructure.aspects.visible) {
            historicStructure.value = false
        }
        if (propertyEligibility && propertyEligibility.value === undefined && propertyEligibility.aspects.visible) {
            propertyEligibility.value = false
        }
        if (_.get(submissionVM, 'lobData.homeowners.coverables.construction.hasCertificateOfComplianceGlazedRetrofit_TWIA.aspects.visible') &&
         _.get(submissionVM, 'lobData.homeowners.coverables.construction.hasCertificateOfComplianceGlazedRetrofit_TWIA.value') === undefined) {
            _.set(submissionVM, 'lobData.homeowners.coverables.construction.hasCertificateOfComplianceGlazedRetrofit_TWIA.value', false);
        }
        setYearMismatchValidationMessage([]);
        if (yearBuilt !== undefined && constructionDate !== undefined && constructionDate.year !== yearBuilt) {
            setYearMismatchValidationMessage([translator(messages.yearMustmatch)])
        }
        setDateMismatchValidationMessage([]);
        setFutureYearValidationMessage([]);
        determineFutureDate(constructionDate);
        setHistoricStructureVisibility();
        updateWizardData(submissionVM)
        setYearBuiltSnapshot(_.clone(yearBuilt));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        configureBuildingCodeClassTWIA()
        configureBuildingCodeTWIA()
    }, [])

    useEffect(() => {
        if (hasMSBDataRefreshed && yearBuiltSnapshot !== yearBuilt) {
            _.set(submissionVM, 'lobData.homeowners.coverables.construction.buildingCodeClass_TWIA.value', undefined);
            _.set(submissionVM, 'lobData.homeowners.coverables.construction.buildingCode_TWIA.value', undefined);
            configureBuildingCodeClassTWIA();
            configureBuildingCodeTWIA();
            updateWizardData(submissionVM);
            setYearBuiltSnapshot(_.clone(yearBuilt));
        }
    }, [hasMSBDataRefreshed, yearBuilt]);
        

    const writeValue = useCallback((value, path) => {
        _.set(submissionVM, path, value);
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);

    const configureBuildingCodeClassTWIA = useCallback(() => {

        if (_.get(submissionVM, 'lobData.homeowners.policyType_TWIA.value.code') === 'TWRM') {
            setShowBuildingCodeClass(false)
        } else {
            const hasWPI8Issued = _.get(submissionVM, 'lobData.homeowners.coverables.construction.hasWPI8CertOfCompIssued_TWIA.value');
            const hasRetrofitIssued = _.get(submissionVM, 'lobData.homeowners.coverables.construction.hasCertificateOfComplianceGlazedRetrofit_TWIA.value');
            const availableBuildingCodeClasses = submissionVM.lobData.homeowners.coverables.construction.buildingCodeClass_TWIA?.aspects.availableValues;

            TWIAHoConstructionUtil.filterBuildingCodeClassesTWIA(
                availableBuildingCodeClasses,
                _.get(submissionVM, 'lobData.homeowners.coverables.construction.originalConstDate_TWIA.value'),
                hasWPI8Issued === true, hasRetrofitIssued === true

            );

            setShowBuildingCodeClass(false)
            setBuildingCodeClassAvailableValues([])

            if (availableBuildingCodeClasses?.length > 0) {
                const buildingCodeClassList = availableBuildingCodeClasses.map((code) => {
                    return {
                        code: code.code,
                        name: translator({ id: code.name })
                    }
                })
                setShowBuildingCodeClass(true)
                setBuildingCodeClassAvailableValues(buildingCodeClassList)
            }
        }
    }, [submissionVM, translator])

    const configureBuildingCodeTWIA = useCallback(() => {
        if (_.get(submissionVM, 'lobData.homeowners.policyType_TWIA.value.code') === 'TWRM') {
            setShowBuildingCode(false)
        } else {
            const availableBuildingCodes = submissionVM.lobData.homeowners.coverables.construction.buildingCode_TWIA?.aspects.availableValues;

            TWIAHoConstructionUtil.filterBuildingCodesTWIA(
                availableBuildingCodes,
                _.get(submissionVM, 'lobData.homeowners.coverables.construction.buildingCodeClass_TWIA.value'),
                _.get(submissionVM, 'lobData.homeowners.coverables.construction.originalConstDate_TWIA.value'),
            );

            setShowBuildingCode(false)
            setBuildingCodeAvailableValues([])

            if (availableBuildingCodes?.length > 0) {
                const buildingCodeList = availableBuildingCodes.map((code) => {
                    return {
                        code: code.code,
                        name: translator({ id: code.name })
                    }
                })
                setBuildingCodeAvailableValues(buildingCodeList)

                // 2024-06-26 - Debra Frum - DE15525 - Feature Testing_Portals_ PE_TWIA_Res Quote_Building Code field should be populated based 
                //                                     on Building code class field in Additional construction details for dwelling policy type
                // Hide Building Code until Building Code Class is defined
                if (_.get(submissionVM, 'lobData.homeowners.coverables.construction.buildingCodeClass_TWIA.value') !==  undefined) {
                    setShowBuildingCode(true)
                }
            }
        }
    }, [submissionVM, translator])

    const setHistoricStructureVisibility = useCallback(() => {
        const structureTypeCode = structureType.code;
        const minimumYear = new Date().getFullYear() - MIN_YEARS_QUALIFY_HISTORIC_STRUCTURE
        const yearBuild = parseInt(yearBuilt)
        setHistoricStructureAvailable(false)

        switch (policyTypeCode) {
            case 'TWRD':
                if ((structureTypeCode === 'DwellingOutBuild' || structureTypeCode === '1Family' || structureTypeCode === '2Family'
                    || structureTypeCode === 'IndividuallyTH' || structureTypeCode === 'PublicHousing')
                    && yearBuild < minimumYear) {
                    setHistoricStructureAvailable(true)
                }
                break;
            case 'TWRP':
                if (yearBuild < minimumYear) {
                    setHistoricStructureAvailable(true)
                }
                break;
            case 'TWRC':
                if (yearBuild < minimumYear) {
                    setHistoricStructureAvailable(true)
                }
                break;
            case 'TWRM':
                setHistoricStructureAvailable(false)
                break;
            default:
        }

    }, [yearBuilt])

    const buildingCodeClassChange = useCallback(
        (value, path) => {
            _.set(submissionVM, path, value);

            // 2024-06-26 - Debra Frum - DE15525 - Feature Testing_Portals_ PE_TWIA_Res Quote_Building Code field should be populated based 
            //                                     on Building code class field in Additional construction details for dwelling policy type
            // Clear Building Code when Building Code Class is changed
            _.set(submissionVM, 'lobData.homeowners.coverables.construction.buildingCode_TWIA.value', undefined);

            configureBuildingCodeTWIA();
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, configureBuildingCodeTWIA]);

    const handleValueChange = useCallback(
        (value, path) => {
            _.set(submissionVM, path, value);
            // DE19151
            if (["hasCertificateOfComplianceGlazedRetrofit_TWIA", "hasWPI8CertOfCompIssued_TWIA"].some((key) => path.includes(key)) && !value) {
                _.set(submissionVM, 'lobData.homeowners.coverables.construction.buildingCodeClass_TWIA.value', undefined);
                _.set(submissionVM, 'lobData.homeowners.coverables.construction.buildingCode_TWIA.value', undefined);
            }
            configureBuildingCodeClassTWIA();
            configureBuildingCodeTWIA(); // 2024-06-26 - Debra Frum - DE15525
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, configureBuildingCodeClassTWIA]);

    const determineFutureDate = useCallback((value) =>{
        const currentDate = new Date();
        const enteredDate = !_.isUndefined(value) ? new Date(value.year, value.month, value.day) : undefined;
        
        if (!_.isUndefined(enteredDate) && ( enteredDate > currentDate)){
            setFutureYearValidationMessage([translator(messages.cannotBeFutureDate)]);
        }
        else {
            setFutureYearValidationMessage([]);
        }
    }, []);

    const constructionDateChange = useCallback(
        (value, path) => {
            _.set(submissionVM, path, value);
            _.set(submissionVM, 'lobData.homeowners.coverables.construction.hasWPI8CertOfCompIssued_TWIA.value', undefined);
            _.set(submissionVM, 'lobData.homeowners.coverables.construction.hasCertificateOfComplianceGlazedRetrofit_TWIA.value', undefined);

            // 2024-06-26 - Debra Frum - DE15525 - Feature Testing_Portals_ PE_TWIA_Res Quote_Building Code field should be populated based 
            //                                     on Building code class field in Additional construction details for dwelling policy type
            // Clear Building Codes when Original Construction Date is changed
            _.set(submissionVM, 'lobData.homeowners.coverables.construction.buildingCodeClass_TWIA.value', undefined);
            _.set(submissionVM, 'lobData.homeowners.coverables.construction.buildingCode_TWIA.value', undefined);

            setDateMismatchValidationMessage([]);
            setYearMismatchValidationMessage([]);
            setFutureYearValidationMessage([]);

            configureBuildingCodeClassTWIA();
            configureBuildingCodeTWIA(); // 2024-06-26 - Debra Frum - DE15525

            if (_.isUndefined(value) && 
            (submissionVM.lobData.homeowners.coverables.construction
                .originalConstDate_TWIA.aspects.required)) {
                setDateMismatchValidationMessage([translator(messages.dateMustmatch)]);
            } else {
                if (yearBuilt !== undefined && value && value.year !== parseInt(yearBuilt)) {
                    setYearMismatchValidationMessage([translator(messages.yearMustmatch)]);
                }

                determineFutureDate(value);
            }
            updateWizardData(submissionVM);
        },
        [submissionVM, configureBuildingCodeClassTWIA, configureBuildingCodeTWIA, 
            updateWizardData, translator, yearBuilt, determineFutureDate]);

        const checkValidDate = useCallback(() => {
            let validationMessages = [];
        
            if (!_.isEmpty(dateMismatchValidationMessage)) {
                validationMessages.push(...dateMismatchValidationMessage);
            }
        
            // DE18038
            if (yearBuilt !== undefined && constructionDate !== undefined 
                     // eslint-disable-next-line radix
                     && parseInt(constructionDate.year) !== parseInt(yearBuilt)) {
                validationMessages.push([translator(messages.yearMustmatch)]);
            }
        
            if (!_.isEmpty(futureYearValidationMessage)) {
                validationMessages.push(...futureYearValidationMessage);
            }

            return validationMessages;
        }, [dateMismatchValidationMessage, yearBuilt, constructionDate,
             futureYearValidationMessage, translator]);
        

    const resetBuildingCodeDetails = useCallback(() => {

        if (constructionDate === undefined || constructionDate === "") {
            _.set(submissionVM, 'lobData.homeowners.coverables.construction.buildingCodeClass_TWIA.value', undefined);
            _.set(submissionVM, 'lobData.homeowners.coverables.construction.buildingCode_TWIA.value', undefined);
            setShowBuildingCode(false)
            setShowBuildingCodeClass(false)
            updateWizardData(submissionVM);
            refreshData();
        }
    });

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
            showRequired: true
        },
        buildingCodeClass: {
            visible: constructionDate !== undefined && showBuildingCodeClass && _.get(submissionVM, 'lobData.homeowners.coverables.construction.buildingCodeClass_TWIA.aspects.visible'),
            availableValues: buildingCodeClassAvailableValues,
            required: _.get(submissionVM, 'lobData.homeowners.coverables.construction.buildingCodeClass_TWIA.aspects.required')
        },
        buildingCode: {
            visible: constructionDate !== undefined && showBuildingCodeClass && showBuildingCode && _.get(submissionVM, 'lobData.homeowners.coverables.construction.buildingCode_TWIA.aspects.visible'),
            availableValues: buildingCodeAvailableValues,
            required: _.get(submissionVM, 'lobData.homeowners.coverables.construction.buildingCode_TWIA.aspects.required'),
        },
        constructionDate: {
            label: _.get(submissionVM, 'lobData.homeowners.policyType_TWIA.value.code') === 'TWRM' ? messages.addedLivingSpConDate : messages.orgConstructionDate,
           // DE15510
            required: _.get(submissionVM, 'lobData.homeowners.policyType_TWIA.value.code') !== 'TWRM',
            validationMessages: checkValidDate(),
            disabled: isEitherChangeOrRenewal && _.get(submissionVM, 'lobData.homeowners.policyType_TWIA.value.code') !== 'TWRM' //DE17137, DE17305
            
        },
        historicStructureException: {
            //visible: historicStructureAvilable, 
            required: _.get(submissionVM, 'lobData.homeowners.coverables.construction.hasQualifyForHistStruct_TWIA.aspects.visible'),
            showRequired: true
        },
        WPI8Certificate: {
            required:  _.get(submissionVM, 'lobData.homeowners.coverables.construction.hasWPI8CertOfCompIssued_TWIA.aspects.visible'),
            showRequired: true
        },
        moreInfoContainer: {
            visible: _.get(submissionVM, 'lobData.homeowners.coverables.construction.hasSB1702EligibilityException_TWIA.aspects.visible'),
        },
        propertyEligibilityException: {
            //visible: _.get(submissionVM, 'lobData.homeowners.coverables.construction.hasSB1702EligibilityException_TWIA.aspects.visible'),
            required: _.get(submissionVM, 'lobData.homeowners.coverables.construction.hasSB1702EligibilityException_TWIA.aspects.visible'),
            showRequired: true  
        },
        certificateOfComplianceRetrofit: {
            visible: _.get(submissionVM, 'lobData.homeowners.coverables.construction.hasCertificateOfComplianceGlazedRetrofit_TWIA.aspects.visible'),
            required: _.get(submissionVM, 'lobData.homeowners.coverables.construction.hasCertificateOfComplianceGlazedRetrofit_TWIA.aspects.visible'),
            showRequired: _.get(submissionVM, 'lobData.homeowners.coverables.construction.hasCertificateOfComplianceGlazedRetrofit_TWIA.aspects.visible')
        }
    }

    const resolvers = {
        resolveCallbackMap: {
            OnBuildingCodeClassChange: buildingCodeClassChange,
            OnHandleValueChange: handleValueChange,
            onResetBuildingCodeDetails: resetBuildingCodeDetails,
            OnConstructionDateChange: constructionDateChange
        },
        // resolveClassNameMap: styles
    }

    return (
        <ViewModelForm
            uiProps={metadata.pageContent} 
            overrideProps={overrideProps}
            model={submissionVM}
            onModelChange={updateWizardData}
            showErrors={showErrors}
            onValueChange={writeValue}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            onValidationChange={setComponentValidation}
        />
    )
}

export default TWIAAdditionalDetails